import { render, staticRenderFns } from "./HolidayNew.vue?vue&type=template&id=732b2214"
import script from "./HolidayNew.vue?vue&type=script&lang=js"
export * from "./HolidayNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports